const avatarText = value => {
  if (!value) return ''
  const nameArray = value.split(' ')
  const count = nameArray.length - 1
  return `${nameArray[0].substr(0, 1)}${nameArray[count].substr(0, 1)}`
}

export { avatarText as default }
